import React from 'react'
import { usePropertyMetadata } from '../contexts/PropertyMetadataContext'

const PropertyConditionOptions = ({ valuationOnly = false, exclude = [] }) => {
  const { propertyConditions, propertyConditionGroups, valuationConditions } = usePropertyMetadata()
  const excluded = new Set(exclude)
  const availableConditions = (valuationOnly ? valuationConditions : propertyConditions).filter(({ value }) => !excluded.has(value))

  return propertyConditionGroups.map((group) => {
    const groupedConditions = availableConditions.filter((condition) => condition.group === group.id)
    if (!groupedConditions.length) return null
    return (
      <optgroup key={group.id} label={group.label}>
        {groupedConditions.map((condition) => (
          <option key={condition.value} value={condition.value}>
            {condition.label}
          </option>
        ))}
      </optgroup>
    )
  })
}

export default PropertyConditionOptions
